export const convertSecondsToDays = (seconds: number): number => seconds / 86400
